var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#136485"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87024 17.4409C4.69168 17.003 3.61788 16.3232 2.71799 15.4451L2.80067 15.3006C4.14392 13.1783 5.35049 10.9817 6.25892 8.63494C7.22249 6.14587 7.99367 3.591 8.7283 1.026C8.79411 0.797063 8.8723 0.572062 8.9443 0.345375C9.02192 0.43425 9.05005 0.516937 9.07368 0.60075C9.53492 2.24662 9.98099 3.897 10.4597 5.53725C11.3315 8.52581 12.5578 11.3608 14.1817 14.0181C14.3713 14.3274 14.6936 14.8461 15.1492 15.5717C14.1793 16.4808 13.02 17.1635 11.7545 17.5708C10.8219 14.7247 9.88406 11.8803 8.94093 9.03769L8.8543 9.03656C8.19842 10.8799 7.20392 13.6811 5.87024 17.4409ZM9.04218 0.0275625H8.97242L8.99999 0L9.04218 0.0275625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcn);
export default __webpack_public_path__ + "static/media/dcn.24200c866ae65eb6cb925b70b136f792.svg";
export { ForwardRef as ReactComponent };